import { render, staticRenderFns } from "./mailCollapsePanel.vue?vue&type=template&id=5e265c96"
import script from "./mailCollapsePanel.vue?vue&type=script&lang=js"
export * from "./mailCollapsePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e265c96')) {
      api.createRecord('5e265c96', component.options)
    } else {
      api.reload('5e265c96', component.options)
    }
    module.hot.accept("./mailCollapsePanel.vue?vue&type=template&id=5e265c96", function () {
      api.rerender('5e265c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/mailCollapsePanel.vue"
export default component.exports